export default __webpack_public_path__ + "static/media/97.fc0d0469.jpg";